import React from 'react';

const PRESET_COLORS = ['#0F9D71', '#2E5CE6', '#0EA5A4', '#6366F1', '#DB2777', '#EA580C'];

const ThemeColorCard = ({ color, onChange }) => (
  <div className="bg-white rounded-xl shadow p-6">
    <h3 className="font-semibold mb-4">主题色</h3>
    <div className="flex items-center space-x-3">
      <input type="color" value={color}
        onChange={e => onChange(e.target.value)}
        className="w-12 h-12 rounded-lg cursor-pointer border border-gray-300" />
      <div>
        <p className="text-sm font-medium">{color}</p>
        <p className="text-xs text-gray-400">H5 端主题色</p>
      </div>
    </div>
    <div className="flex flex-wrap gap-2 mt-3">
      {PRESET_COLORS.map(c => (
        <button key={c}
          onClick={() => onChange(c)}
          className={`w-8 h-8 rounded-full border-2 ${color === c ? 'border-gray-800 scale-110' : 'border-transparent'}`}
          style={{ backgroundColor: c }} />
      ))}
    </div>
  </div>
);

export default ThemeColorCard;